export default () => {
  const list = document.querySelectorAll(".is-style-list-read-more");
  if (!list) {
    return;
  }

  list.forEach((item) => {
    item.style.display = "none";

    const readMoreItem = document.createElement("a");
    readMoreItem.textContent = "mehr anzeigen";
    readMoreItem.classList.add("readmore");

    readMoreItem.addEventListener("click", (e) => {
      e.preventDefault();
      item.style.display = "block";
      readMoreItem.style.display = "none";
    });

    item.parentElement.appendChild(readMoreItem);
  });
}
